export const DOCUMENT_TYPE_SEARCH_FRONTPAGE = 'search-frontpage';
